import { Link } from '@tanstack/react-router';
import {
  BookMarkedIcon,
  HouseIcon,
  SlidersHorizontalIcon,
  UsersIcon,
} from 'lucide-react';

import { LogoutButton } from './logout-button';
import { NavItem } from './nav-item';
import { ProfileLink } from './profile-link';

import './sidebar.scss';

function Sidebar() {
  return (
    <div className="sidebar">
      <Link
        // @ts-expect-error - TODO: fix this
        to="https://worldathletics.org/"
        target="_blank"
        href="https://worldathletics.org/"
        title="World Athletics"
        className="sidebar__logo"
      >
        <img src="/logo.svg" alt="World Athletics" />
      </Link>

      <nav className="sidebar__menu">
        <NavItem to="/documents" icon={<HouseIcon size={26} />} label="Home" />
        <NavItem
          to="/annex"
          icon={<BookMarkedIcon size={26} />}
          label="Annex"
        />
        <NavItem
          to="/parameters"
          icon={<SlidersHorizontalIcon size={26} />}
          label="Parameters"
        />
        <NavItem
          to="/users"
          icon={<UsersIcon size={26} />}
          label="Users"
          roles={['admin']}
        />
        <LogoutButton />
      </nav>

      <ProfileLink />
    </div>
  );
}

export { Sidebar };
